<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Dedication-rw" epub:type="frontmatter dedication" id="Dedication2">
<div class="title-block-rw" id="dedication2">
<p id="p2719"><i>Happy Birthday, Grandma</i></p>
</div>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s004-Dedication-01.vue?422b4888